import {
    IonAvatar,
    IonCol, 
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonNote,
    IonRow,
    IonThumbnail
} from '@ionic/react';

import { Dialog, ConfirmResult } from '@capacitor/dialog';
import React, { Component }  from 'react';

import { LANGUAGE, GetStr } from "../language/Language";

export const showInfo = async (cap : string, msg : string) => {
    await Dialog.alert({
        title: cap,
        message: msg,
        buttonTitle: GetStr(LANGUAGE.TXT_ERROR_CLOSE)
  });
};

export const showAlert = async (msg : string) => {
    await Dialog.alert({
        title: GetStr(LANGUAGE.TXT_ERROR_CAP)!,
        message: msg,
        buttonTitle: GetStr(LANGUAGE.TXT_ERROR_CLOSE)
  });
};

export const showConfirm = async (title: string, msg : string) : Promise<ConfirmResult> => {
    return await Dialog.confirm({
        title: title,
        message: msg,
        okButtonTitle: GetStr(LANGUAGE.TXT_OK),
        cancelButtonTitle: GetStr(LANGUAGE.TXT_CANCEL)
    });
};